import * as ng from 'angular';
import * as _ from 'underscore';

import {Dataset} from '..';
import {BarChart} from './bar-chart.service';
import {LineChart} from './line-chart.service';


ng.module('e360').factory('barChartCustomFactory', barChartCustomFactory);

barChartCustomFactory.$inject = ['instanceServiceFactory'];
function barChartCustomFactory(instanceServiceFactory) {
   return instanceServiceFactory(BarChartCustom);
}

// Requires that object data has a single series defined, could contain more than one
export class BarChartCustom extends BarChart {
   static $inject = ['ds'];
   protected constructor(protected ds: Dataset) {
      super(ds);
   }

   setData(data: any[]) {
      while (this.chart.series.length > 0) {
         this.chart.series.pop().remove();
      }
      if (data.length === 0) return;
      var seriesRow: number = 0;

      let xAxis = this.ds.xAxis;
      let yAxis = this.ds.yAxis;

      this.chart.update({
         xAxis: {
            categories: _.map(data, d => LineChart.formatValue(xAxis, d[xAxis.name])),
            title: { text: xAxis.label }
         },
         yAxis: {
            title: { text: yAxis.label }
         }
      });

      this.chart.addSeries({
         name: seriesRow.toString(),
         data: _.map(data, (d) => d[yAxis.name])
      });
      seriesRow += 1;

      let maxRange = 0;
      _.each(data, (rowData, item) => {
         if (rowData.totalReg > maxRange) maxRange = rowData.totalReg;
      });

      // generate some random data for demo purposes
      let dataClone = _.clone(data);
      _.forEach(dataClone, function (row) {
         let addOrSubtract = Math.random() > 0.5 ? true : false;
         let random = Math.floor(Math.random() * maxRange);
         row.totalReg = addOrSubtract
            ? row.totalReg + random
            : row.totalReg - random > 0
            ? row.totalReg - random
            : random - row.totalReg;
      });
      this.chart.addSeries({
         name: seriesRow.toString(),
         data: _.map(data, (d) => d[yAxis.name])
      });
      seriesRow += 1;

      dataClone = _.clone(data);
      _.forEach(dataClone, function (row) {
         let addOrSubtract = Math.random() > 0.5 ? true : false;
         let random = Math.floor(Math.random() * maxRange);
         row.totalReg = addOrSubtract
            ? row.totalReg + random
            : row.totalReg - random > 0
            ? row.totalReg - random
            : random - row.totalReg;
      });
      this.chart.addSeries({
         name: seriesRow.toString(),
         data: _.map(data, (d) => d[yAxis.name])
      });
      seriesRow += 1;

      dataClone = _.clone(data);
      _.forEach(dataClone, function (row) {
         let addOrSubtract = Math.random() > 0.5 ? true : false;
         let random = Math.floor(Math.random() * maxRange);
         row.totalReg = addOrSubtract
            ? row.totalReg + random
            : row.totalReg - random > 0
            ? row.totalReg - random
            : random - row.totalReg;
      });
      this.chart.addSeries({
         name: seriesRow.toString(),
         data: _.map(data, (d) => d[yAxis.name])
      });
      seriesRow += 1;
   }
}

export interface BarChartCustomFactory {
   ({ds: Dataset}): BarChartCustom;
}
